import { InjectionToken } from '@angular/core';
import { IOpenWithConfig } from './plugins.config';

export const IDE_CODE_VIEW_CONFIG = new InjectionToken<IdeCodeViewConfig>('IDE_CODE_VIEW_CONFIG');

/**
 * 代码视图全局配置
 */
export interface IdeCodeViewConfig {

  /** 文件后缀名到打开该文件所需的插件地址的映射 */
  fileSuffix2PluginsUrlMap?: IOpenWithConfig;

}
